/** Matches API `PhysicalStateDetailApiModel` / `RegPhysicalState` JSON (camelCase). */
export interface IPhysicalStateDetail {
    id: string;
    code: string;
    description: string;
    isActive: boolean;
    isDeleted: boolean;
    source: string;
    sourceVersion: string;
    effectiveFromUtc: string;
    createdAtUtc: string;
    updatedAtUtc: string;
    createdByDisplayName?: string | null;
    lastUpdatedByDisplayName?: string | null;
    deletedAuditAtUtc?: string | null;
    deletedByDisplayName?: string | null;
    disabledAuditAtUtc?: string | null;
    disabledByDisplayName?: string | null;
}

export type PhysicalStateCreatePayload = {
    code: string;
    description: string;
    isActive?: boolean;
};

export type PhysicalStateUpdatePayload = {
    id: string;
    code: string;
    description: string;
};

export const PHYSICAL_STATE_CREATE_CONFLICT = {
    deletedRestoreAvailable: "physicalState.deletedRestoreAvailable",
    duplicateActive: "physicalState.duplicateActive",
} as const;
